<div class="layout-container" [class.is-resizing]="isResizing">
  <header class="app-header">
    <div class="header-brand">
      <button
        type="button"
        class="icon-btn sidebar-toggle"
        (click)="toggleSidebar()"
        [attr.aria-label]="isSidebarOpen ? 'Закрыть меню' : 'Открыть меню'"
        [attr.aria-expanded]="isSidebarOpen"
        aria-controls="app-sidebar"
      >
        <svg
          *ngIf="!isSidebarOpen"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>

        <svg
          *ngIf="isSidebarOpen"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>

      <div class="brand-logo" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M3 10l9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V10z" />
          <path d="M8.5 14a5 5 0 0 1 7 0" />
          <path d="M10.5 17a2.5 2.5 0 0 1 3 0" />
          <path d="M12 19.5h.01" />
        </svg>
      </div>

      <span class="brand-name">Управление реле Лоран</span>
    </div>

    <div class="header-actions">

      <button
        type="button"
        class="btn btn-outline theme-toggle"
        (click)="themeService.toggle()"
        [attr.aria-label]="themeService.isDark() ? 'Включить светлую тему' : 'Включить тёмную тему'"
        [attr.aria-pressed]="themeService.isDark()"
        [title]="themeService.isDark() ? 'Светлая тема' : 'Тёмная тема'"
      >
        <svg
          *ngIf="themeService.isDark()"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2" />
          <path d="M12 20v2" />
          <path d="M4.93 4.93l1.41 1.41" />
          <path d="M17.66 17.66l1.41 1.41" />
          <path d="M2 12h2" />
          <path d="M20 12h2" />
          <path d="M6.34 17.66l-1.41 1.41" />
          <path d="M19.07 4.93l-1.41 1.41" />
        </svg>

        <svg
          *ngIf="themeService.isLight()"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>

      </button>

      <button
        type="button"
        class="btn btn-outline"
        *ngIf="authService.isAdmin()"
        (click)="goToAdmin()"
        aria-label="Админ-панель"
        title="Админ-панель"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>

        <span class="btn-label">Админ</span>
      </button>

      <button
        type="button"
        class="btn btn-outline"
        *ngIf="authService.isAdmin()"
        aria-label="Профиль"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>

        <span class="btn-label">Профиль</span>
      </button>

      <button
        type="button"
        class="btn btn-primary"
        (click)="logout()"
        aria-label="Выйти"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>

        <span class="btn-label">Выйти</span>
      </button>
    </div>
  </header>

  <main class="main-content" [class.is-single-node]="isSingleNodeMode">
    <div
      class="sidebar-overlay"
      *ngIf="isSidebarOpen && showSidebar"
      (click)="closeSidebar()"
      aria-hidden="true"
    ></div>

    <aside
      id="app-sidebar"
      class="sidebar-tree"
      *ngIf="showSidebar"
      [class.is-open]="isSidebarOpen"
      [style.width.%]="isDesktop ? sidebarWidthPercent : null"
    >
      <app-tree
        (leafNodeClick)="onNodeSelected($event)"
        (treeStateChange)="onTreeStateChange($event)"
      ></app-tree>
    </aside>

    <div
      class="resizer"
      *ngIf="isDesktop && showSidebar"
      (pointerdown)="startResizing($event)"
      title="Перетащите для изменения ширины"
      role="separator"
      aria-orientation="vertical"
    >
      <div class="resizer-line"></div>
    </div>

    <section class="content-details">
      <div *ngIf="isNoAccess" class="no-access-state">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>

        <h3>Нет доступа</h3>
        <p>У вас нет доступа ни к одному объекту.</p>
      </div>

      <app-relay-dashboard
        *ngIf="!isNoAccess"
        [node]="selectedNode"
      ></app-relay-dashboard>
    </section>
  </main>
</div>
